/**
 * Dependencies
 */
import http from '../../../../../services/HttpService'

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

/**
 * Get the opex for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
const getData = ({commit, rootState, state}) => {
    let id = rootState.route.params.projectId

    commit('LOAD_DATA')
    http.get(`projects/${id}/opex-summary/?scope=t12-vs-proforma`)
        .then(res => commit('GET_DATA_SUCCESS', {
            data: res.data.data['opex-summaries'],
            meta: res.data.meta
        }))
        .catch(() => commit('GET_DATA_FAILURE'))
}

/**
 * Update the search term
 *
 * @param  {Function} options.commit
 * @param  {String} term
 * @return {Promise}
 */
const updateSearchTerm = ({ commit }, term) => commit('UPDATE_SEARCH_TERM', term)

/**
 * Paginate the dataset forward
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const nextPage = ({ commit }) => commit('UPDATE_PAGE_NEXT')

/**
 * Paginate the dataset backward
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const prevPage = ({ commit }) => commit('UPDATE_PAGE_PREV')

/**
 * Toggle the create form
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const toggleCreateForm = ({ commit }) => commit('TOGGLE_CREATE_FORM')

/**
 * Generate new operating expense
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @param  {Object} data
 * @return {Promise}
 */
const createNewRelativeOpex = ({ commit, rootState }, data) => {
    let url = `projects/${rootState.route.params.projectId}/relative-opex/?scope=t12-vs-proforma`
    commit('SET_UPDATING')
    return new Promise((resolve, reject) => {
        http.post(url, data)
            .then(res => {
                commit('NEW_OPEX_SUCCESS', res.data)
                commit('RESET_UPDATING')
                resolve(res.data)
            })
            .catch(err => {
                commit('NEW_OPEX_FAILURE', err)
                commit('RESET_UPDATING')
                reject(err)
            })
    })
}

const createNewRegularOpex = ({ commit, rootState }, data) => {
    let url = `projects/${rootState.route.params.projectId}/regular-opex/?scope=t12-vs-proforma`
    commit('SET_UPDATING')
    return new Promise((resolve, reject) => {
        http.post(url, data)
            .then(res => {
                commit('NEW_OPEX_SUCCESS', res.data)
                commit('RESET_UPDATING')
                resolve(res.data)
            })
            .catch(err => {
                commit('NEW_OPEX_FAILURE', err)
                commit('RESET_UPDATING')
                reject(err)
            })
    })
}

/**
 * Update an existing opex item
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
const updateOpex = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        http.put(payload.url, payload.data)
            .then(res => {
                commit('REPLACE_OPEX', res.data)
                resolve(res.data)
            })
            .catch(err => {
                reject(err.response.data)
            })
    })
}

/**
 * Delete an existing opex item
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
const deleteOpex = ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
        http.del(`modelling/${payload.type}/${payload.id}/`)
            .then(res => {
                commit('DELETE_OPEX', payload.id)
                resolve(payload.id)
            })
            .catch(err => reject(err.response.data))
    })
}

export default {
    getData,
    nextPage,
    prevPage,
    deleteOpex,
    updateOpex,
    resetState,
    toggleCreateForm,
    updateSearchTerm,
    createNewRegularOpex,
    createNewRelativeOpex
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/opex-pro-forma/actions.js